import { localDateTypePolicy as localDateTypePolicy } from '@/graphql/scalars';

export const scalarTypePolicies = {
  AdminUserRow: {
    fields: {
      last_seen_on: localDateTypePolicy,
    },
  },
  BilderitModuleEnabled: {
    fields: {
      end_date: localDateTypePolicy,
    },
  },
  Checklist: {
    fields: {
      completed_date: localDateTypePolicy,
    },
  },
  ChecklistItem: {
    fields: {
      value_date: localDateTypePolicy,
    },
  },
  CompanyActivitySummary: {
    fields: {
      lastActivityDate: localDateTypePolicy,
    },
  },
  DailyReport: {
    fields: {
      date: localDateTypePolicy,
    },
  },
  DateInSequence: {
    fields: {
      value: localDateTypePolicy,
    },
  },
  Document: {
    fields: {
      expiration_date: localDateTypePolicy,
    },
  },
  Employee: {
    fields: {
      birthday: localDateTypePolicy,
    },
  },
  EmployeeInterface: {
    fields: {
      birthday: localDateTypePolicy,
    },
  },
  Machine: {
    fields: {
      last_status_on: localDateTypePolicy,
    },
  },
  MachineAssignmentReport: {
    fields: {
      end_date: localDateTypePolicy,
      start_date: localDateTypePolicy,
    },
  },
  MachineDayReportSummary: {
    fields: {
      date: localDateTypePolicy,
    },
  },
  MachinistDayWorkSummary: {
    fields: {
      date: localDateTypePolicy,
    },
  },
  Me: {
    fields: {
      birthday: localDateTypePolicy,
    },
  },
  MyDailyReportSummary: {
    fields: {
      date: localDateTypePolicy,
    },
  },
  NextService: {
    fields: {
      date: localDateTypePolicy,
    },
  },
  PartialProfile: {
    fields: {
      birthday: localDateTypePolicy,
    },
  },
  ProjectsDayStats: {
    fields: {
      date: localDateTypePolicy,
    },
  },
  RentalCertificationRelocationSnapshot: {
    fields: {
      movement_date: localDateTypePolicy,
    },
  },
  ServiceReport: {
    fields: {
      date: localDateTypePolicy,
      date_in_sequence: localDateTypePolicy,
    },
  },
  ServiceSequenceItem: {
    fields: {
      date: localDateTypePolicy,
      date_in_sequence: localDateTypePolicy,
    },
  },
  User: {
    fields: {
      birthday: localDateTypePolicy,
    },
  },
  VisionLinkReportsByDateResult: {
    fields: {
      date: localDateTypePolicy,
    },
  },
  WorkOrderHours: {
    fields: {
      execution_date: localDateTypePolicy,
    },
  },
};
